import { MENTOR_ONBOARDING_TYPES } from 'src/consumer/constants'

export function getMentorJoinEmailInvalidity(profileData, formEmailInputValidity, formEmailInput) {
  console.log({ formEmailInputValidity })
  if (profileData?.mobileVerified) {
    if (formEmailInput?.length > 0) {
      return !formEmailInputValidity
    }
    return false
  }
  return !formEmailInputValidity
}

export function getMentorJoinPageStrings({ onboardingType }) {
  let strings = {
    seo: {
      title: 'Become a Mentor Today! | AUMHUM',
      description:
        'Apply today to join AUMHUM as a therapist or psychiatric provider online, full-time or part-time.',
    },
    subTitle: 'For Mentors',
    title: 'Heal, Share, Inspire',
    titleH1: 'Become an AUMHUM Mentor',
    pageInfo: 'Share your knowledge or provide a helping hand with personal sessions.',
    joinText: 'as a Mentor',

    info: {
      headline: 'Unlock Your Potential as a Mentor',
      description:
        'Are you passionate about helping others live healthier, happier lives? We invite therapists, counselors, and psychiatrists to join our dedicated community of mentors.',
    },

    info2: {
      headline: 'Flexible Scheduling',
      description: 'Set your availability and connect with clients at your convenience.',
    },
    joinModal: {
      modalTitle: 'Join AUMHUM Mentors',
      joinButton: 'Become a Mentor',
    },
  }

  switch (onboardingType) {
    case MENTOR_ONBOARDING_TYPES.DOCTOR:
      strings.seo.title = 'AUMHUM for Doctors | AUMHUM'
      strings.seo.description = 'Apply today to join AUMHUM as a doctor online.'
      strings.title = 'Transform your practice and Patient care with AUMHUM'
      strings.subTitle = 'For Doctors'
      strings.titleH1 = ''
      strings.pageInfo = 'Provide medical consultations and support to patients.'
      strings.joinText = 'as a Doctor'
      strings.info.headline = 'Your Medical Expertise Deserves the Best Platform'
      strings.info.description =
        'Join our community of healthcare professionals dedicated to improving patient outcomes, expanding your expertise, and making a real difference in the world of medicine.'
      strings.info2.headline = 'Flexible Scheduling'
      strings.info2.description =
        'Set your availability and connect with clients at your convenience.'
      strings.joinModal.modalTitle = 'Join AUMHUM Doctors'
      strings.joinModal.joinButton = 'Proceed as Doctor'

      break

    case MENTOR_ONBOARDING_TYPES.THERAPIST:
      strings.seo.title = 'AUMHUM for Therapists | AUMHUM'
      strings.seo.description = 'Apply today to join AUMHUM as a therapist online.'
      strings.title = 'Heal, Share & Inspire'
      strings.subTitle = 'For Therapists'
      strings.titleH1 = 'Become an AUMHUM Therapist'
      strings.pageInfo = 'Provide therapy sessions and support to clients.'
      strings.joinText = 'as a Therapist'
      strings.info.headline = 'Unlock Your Potential as a Therapist'
      strings.info.description =
        'Are you passionate about providing therapy to those in need? We invite therapists to join our dedicated community of mental health professionals.'
      strings.info2.headline = 'Flexible Scheduling'
      strings.info2.description =
        'Set your availability and connect with clients at your convenience.'
      strings.joinModal.modalTitle = 'Join AUMHUM Therapists'
      strings.joinModal.joinButton = 'Proceed as Therapist'
      break

    default:
      break
  }

  return strings
}
